export default {
  colors: {
    primary: '#FF0000',
  },
};
